export function getDefaultActiveRole(roles: string[] | null | undefined): string | null {
  if (!roles || roles.length === 0) {
    return null;
  }

  const ordered = getOrderedRoles(roles);
  return ordered[0] ?? null;
}

export function getOrderedRoles(roles: string[] | null | undefined): string[] {
  if (!roles || roles.length === 0) {
    return [];
  }

  const priority = ["superadmin", "administrator", "admin", "operations", "finance", "clinical", "diagnostics"];
  return [...roles].sort((a, b) => {
    const ai = priority.indexOf(a.toLowerCase());
    const bi = priority.indexOf(b.toLowerCase());
    const av = ai === -1 ? 999 : ai;
    const bv = bi === -1 ? 999 : bi;
    return av - bv;
  });
}

export type RoleScope = "platform" | "admin" | "clinical" | "operations" | "diagnostics" | "finance" | "default";

export function resolveRoleScope(role: string | null | undefined): RoleScope {
  const normalized = (role ?? "").toLowerCase();

  if (!normalized) return "default";
  if (normalized.includes("superadmin") || normalized.includes("platform")) return "platform";
  if (normalized.includes("admin") || normalized.includes("administrator")) return "admin";
  if (normalized.includes("clinical") || normalized.includes("doctor") || normalized.includes("nurse")) return "clinical";
  if (normalized.includes("operation") || normalized.includes("dispatch") || normalized.includes("front desk")) return "operations";
  if (normalized.includes("diagnostic") || normalized.includes("lab")) return "diagnostics";
  if (normalized.includes("finance") || normalized.includes("account")) return "finance";

  return "default";
}
